module.exports = __webpack_public_path__ + "static/media/1001368MF.57d38dc9.jpg";